export const FETCH_PROCEDURES_START = 'FETCH_PROCEDURES_START';
export const FETCH_PROCEDURES_SUCCESS = 'FETCH_PROCEDURES_SUCCESS';
export const FETCH_PROCEDURES_FAIL = 'FETCH_PROCEDURES_FAIL';
